var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sport"},[_c('bk-frame',{attrs:{"settings":_vm.settings,"onOrderDisplay":_vm.handleOnOrderDisplay,"onOrderEnabled":_vm.handleOnOrderEnabled,"onOrdered":_vm.handleOnOrdered}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib??vue-loader-options!./skins/xkiosk/pages/sport/sport.vue?vue&type=template&id=5ab46ad2
// module id = 5Yyy
// module chunks = 37